/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  MarkdownImage,
  MarkdownImageCreateInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Upload an image for a Markdown description
 */
export const createMarkdownImage = (
    markdownImageCreateInput: MaybeRefOrGetter<MarkdownImageCreateInput>,
 signal?: AbortSignal
) => {
      markdownImageCreateInput = toValue(markdownImageCreateInput);

      return axiosClient<MarkdownImage>(
      {url: `/markdown-images`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markdownImageCreateInput, signal
    },
      );
    }




export const getCreateMarkdownImageMutationKey = () => ['createMarkdownImage'] as const;

export const getCreateMarkdownImageMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMarkdownImage>>, TError,CreateMarkdownImageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMarkdownImage>>, TError,CreateMarkdownImageMutationVariables, TContext> => {

const mutationKey = getCreateMarkdownImageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMarkdownImage>>, CreateMarkdownImageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createMarkdownImage(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMarkdownImageMutationResult = NonNullable<Awaited<ReturnType<typeof createMarkdownImage>>>
    export type CreateMarkdownImageMutationBody = MarkdownImageCreateInput
    export type CreateMarkdownImageMutationError = ErrorType<ValidationError | StandardError>
    export type CreateMarkdownImageMutationVariables = {data: MarkdownImageCreateInput}

    /**
 * @summary Upload an image for a Markdown description
 */
export const useCreateMarkdownImage = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMarkdownImage>>, TError,CreateMarkdownImageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMarkdownImage>>,
        TError,
        CreateMarkdownImageMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMarkdownImageMutationOptions(options), queryClient);
    }
    /**
 * @summary Show an image embedded in a Markdown description
 */
export const markdownImage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<unknown>(
      {url: `/markdown-images/${id}`, method: 'GET', signal
    },
      );
    }




export const getMarkdownImageQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'markdown-images',id
    ] as const;
    }


export const getMarkdownImageQueryOptions = <TData = Awaited<ReturnType<typeof markdownImage>>, TError = ErrorType<void | SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markdownImage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMarkdownImageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof markdownImage>>> = ({ signal }) => markdownImage(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof markdownImage>>, TError, TData>
}

export type MarkdownImageQueryResult = NonNullable<Awaited<ReturnType<typeof markdownImage>>>
export type MarkdownImageQueryError = ErrorType<void | SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show an image embedded in a Markdown description
 */

export function useMarkdownImage<TData = Awaited<ReturnType<typeof markdownImage>>, TError = ErrorType<void | SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof markdownImage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarkdownImageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






